module.exports = __webpack_public_path__ + "static/media/35.ad178af8.mp3";